export default "__VITE_ASSET__49b3b62f__"